import { Bot, CloudCog, Cpu, Flag, LockKeyhole, Monitor, Settings2, Shield, ShieldCheck } from "lucide-react";

export const services = [
  {
    icon: Bot,
    title: "Intelligence artificielle générative",
    description: "Intégration de modèles IA Microsoft (Copilot, Azure OpenAI) et de solutions alternatives européennes ou open source : Mistral, LLaMA, Hugging Face. Déploiement possible en auto-hébergement sur infrastructure française pour garantir la maîtrise et la confidentialité des données.",
  },
  {
    icon: ShieldCheck,
    title: "Sécurité et conformité",
    description: "Une approche Zero Trust appuyée par Microsoft Purview (classification, DLP, étiquettes de sensibilité) et les outils Microsoft Security pour protéger les données, assurer la conformité RGPD/NIS2 et garantir la continuité d’activité.",
  },
  {
    icon: Shield,
    title: "SOC Microsoft Sentinel",
    description: "Surveillance 24/7/365 de votre infrastructure via Microsoft Sentinel (SIEM/SOAR n\u00b01 Gartner). D\u00e9tection, analyse et neutralisation des menaces en temps r\u00e9el, threat hunting proactif et conformit\u00e9 NIS2/RGPD. En partenariat avec DMC Defense.",
  },
  {
    icon: Cpu,
    title: "Solutions Microsoft",
    description: "Déploiement, administration et adoption de Microsoft 365, Copilot, Purview, Power Platform et Azure. Copilot démultiplie la productivité, Purview sécurise et gouverne les données — le tout accessible quelle que soit la taille de l’entreprise.",
  },
  {
    icon: CloudCog,
    title: "Optimisation Cloud",
    description: "Audit et optimisation des services Cloud pour améliorer les performances, maîtriser les coûts et renforcer le niveau de sécurité.",
  },
  {
    icon: Flag,
    title: "Souveraineté et hébergement européen",
    description: "Conseil et déploiement sur des infrastructures françaises ou européennes, hors écosystème Microsoft si nécessaire, pour répondre aux exigences de souveraineté, de conformité RGPD et de localisation des données.",
  },
  {
    icon: Monitor,
    title: "Matériel et équipements IT",
    description: "Vente et déploiement de matériel professionnel Lenovo : postes de travail, ordinateurs portables, écrans, périphériques (souris, claviers, casques, docks). Des équipements fiables et adaptés à vos usages, avec un accompagnement de A à Z.",
  },
  {
    icon: Settings2,
    title: "Automatisation des processus",
    description: "Des flux Power Automate pensés pour supprimer les tâches répétitives, fiabiliser les validations et réduire les coûts opérationnels.",
  },
  {
    icon: LockKeyhole,
    title: "Adaptation sur mesure",
    description: "Des solutions d’IA et d’intégration calibrées pour les contraintes, la maturité et les ambitions propres à chaque PME.",
  },
];

export const stats = [
  { value: "Zero Trust", label: "Sécurité par conception" },
  { value: "Microsoft", label: "Expertise 365, Copilot, Purview, Azure" },
  { value: "IA", label: "Copilot, Mistral, LLaMA et autres modèles" },
  { value: "Automatisation", label: "Optimisation de process Microsoft et autres" },
  { value: "PME", label: "Accompagnement pragmatique et mesurable" },
];

export const linkedinUrl = "https://www.linkedin.com/company/intelliix/";
